import React from 'react';

// Configs
import { BACKGROUND_COLOR_NOT_SELECTED, BACKGROUND_COLOR_SELECTED } from '../../configs/tools.configs';

const ToolTableIcon = ({ selected = false, title = 'Tool Table Icon' }: { selected: boolean; title?: string }) => {
  const backgroundColor = selected ? BACKGROUND_COLOR_SELECTED : BACKGROUND_COLOR_NOT_SELECTED;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={40}
      height={40}
      fill='none'
      className={'tool-icon'}
      role='img'
      aria-label={title}
    >
      <title>{title}</title>
      <path fill={backgroundColor} d='M0 0h40v40H0z' />
      <path
        fill='#fff'
        d='M14.562 8H4v9.19h10.562V8ZM15.762 38.198h10.564v-9.19H15.762v9.19ZM14.562 29.007H4v9.191h10.562v-9.19ZM14.562 18.504H4v9.19h10.562v-9.19ZM15.762 27.694h10.564v-9.19H15.762v9.19ZM38.098 18.504H27.535v9.19h10.563v-9.19ZM38.098 8H27.535v9.19h10.563V8ZM15.762 17.19h10.564V8H15.762v9.19ZM38.098 29.007H27.535v9.191h10.563v-9.19Z'
      />
    </svg>
  );
};

export default ToolTableIcon;
